@import '../../global/style/all-tenants/custom-properties/components-properties/dynamic-teaser';

:host {
  @include cms-components-host-defaults;
  min-height: -moz-fit-content;
  min-height: fit-content;
}

.headline-wrapper {
  width: var(--cms-container-width);
}

p,
ul,
li {
  margin: 0;
  padding: 0;
}

.badge-wrapper {
  @include dynamic-teaser-badge
}

.teaser-list-container-inner {
  @include cms-default-grid-container;
}

.keyword-list-item {
  margin: 0;
  padding: var(--cms-spacing-050);
  list-style-type: none;
  cursor: pointer;
  color: var(--cms-semanticColors-base-strong-text);

  &:hover {
    background-color: var(--cms-semanticColors-transparency-strong-hover-background);
  }

  &.active {
    background-color: var(--cms-semanticColors-transparency-strong-hover-background);
  }
}

cms-filter-item {
  position: relative;
}

.filter-container {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  width: var(--cms-container-width);
  align-items: flex-start;
  padding: var(--cms-spacing-100) 0;
  margin-bottom: var(--cms-components-mb);
}

.filter-wrapper {
  width: var(--cms-container-width);
  @include cms-default-grid-container;
  z-index: 110;
}

.filter-wrapper>* {
  grid-area: var(--cms-default-grid-area);
}

.current-category-label {
  margin-right: var(--cms-spacing-075);
}

.current-count-teaser {
  color: var(--cms-theme-text-color);
  @include cms-display-teaser-result-count;
}

.current-category-label-wrapper {
  max-width: calc(var(--cms-container-max-width) - var(--cms-spacing-200));
  margin: auto;
  padding: 0 var(--cms-spacing-100);

}

.current-category-label-wrapper cms-headline {
  display: inline-block;
  width: auto;
}

.display-none {
  display: none !important;
}

.more-button-wrapper {
  @include cms-default-grid-container;
}

.load-more-teaser {
  @include cms-load-more-teaser;
}

.scratch svg path {
  fill: var(--cms-semanticColors-base-medium-background);
}

@include media-width($breakpoint-sm) {
  .filter-wrapper {
    --cms-default-grid-area: auto / auto / auto / span 4;
  }

  .all-projects-button {
      --cms-default-grid-area: auto / 5 / auto / span 4;
  }
}

@include media-width($breakpoint-md) {
  .filter-wrapper {
    --cms-default-grid-area: auto / auto / auto / span 3;
  }
    .all-projects-button {
      --cms-default-grid-area: auto / auto / auto / span 3;
  }
}